/**
 * Subnav Collapse — Bootstrap-free accordion for sidenav panels
 * ========================================================================
 * On modern pages Bootstrap JS isn't loaded, so data-toggle="collapse"
 * does nothing. This delegated handler provides the same toggle behavior
 * for accordion groups inside the sidenav panel.
 *
 * Also syncs active-link highlighting and auto-expand after HTMX
 * navigation, since the subnav HTML is loaded once and doesn't re-render.
 */

// ── Manual toggle on click ───────────────────────────────────────────────
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-toggle="collapse"]');
  if (!trigger) return;

  // Only handle collapse toggles inside the sidenav panel
  if (!trigger.closest('.sidenav__panel')) return;

  e.preventDefault();
  e.stopPropagation();   // prevent hx-boost from intercepting the <a>

  var targetSel = trigger.getAttribute('data-target') || trigger.getAttribute('href');
  if (!targetSel || targetSel === '' || targetSel === '#') return;

  var target = document.querySelector(targetSel);
  if (!target) return;

  var isOpen = target.classList.contains('show');
  target.classList.toggle('show', !isOpen);
  trigger.setAttribute('aria-expanded', String(!isOpen));
}, true);  // useCapture — fire before hx-boost

// ── Sync active links + auto-expand from current URL ─────────────────────
// The subnav is loaded once and doesn't re-render on HTMX navigation.
// Compare each link's href against window.location to set .active and
// expand the right collapse group.
function syncCollapseState() {
  var panel = document.querySelector('.sidenav__panel');
  if (!panel) return;

  var currentPath = window.location.pathname;
  var currentSearch = window.location.search;

  // Update .active on all nav-links by comparing href to current URL.
  // Two passes: first activate links with query params (specific views),
  // then activate bare-path links only if no sibling matched (default view).
  var activatedGroups = new Set();

  panel.querySelectorAll('.nav-link[href]').forEach(function (link) {
    if (link.hasAttribute('data-toggle')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var a = document.createElement('a');
    a.href = href;
    var linkPath = a.pathname;
    var linkSearch = a.search;

    if (linkSearch) {
      // Link has query params — match path + all link params present in current URL
      var isActive = linkPath === currentPath && currentSearch.indexOf(linkSearch.slice(1)) !== -1;
      link.classList.toggle('active', isActive);
      if (isActive) {
        var group = link.closest('.collapse');
        if (group) activatedGroups.add(group.id);
      }
    } else {
      // Clear for now — handled in second pass
      link.classList.remove('active');
    }
  });

  // Second pass: bare-path links are active when path matches AND no
  // query-param sibling in the same group already matched (default/fallback)
  var bareMatched = false;
  panel.querySelectorAll('.nav-link[href]').forEach(function (link) {
    if (link.hasAttribute('data-toggle')) return;
    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var a = document.createElement('a');
    a.href = href;
    if (a.search) return;  // skip query-param links (already handled)

    var group = link.closest('.collapse');
    var groupId = group ? group.id : null;
    if (a.pathname === currentPath && (!groupId || !activatedGroups.has(groupId))) {
      link.classList.add('active');
      if (groupId) activatedGroups.add(groupId);
      bareMatched = true;
    }
  });

  // Third pass: prefix-match fallback for detail pages (e.g. /propmgmt/move-outs/80/
  // should keep /propmgmt/move-outs/ highlighted). Without this, unrelated
  // afterSettle events (hx-trigger="load" components etc.) strip the active
  // state that updateSidebarActive set via its own prefix match.
  // Includes query-param links (match on pathname only) so that e.g. a link
  // href="/pm-crm/leads/?group_by=priority" still wins on /pm-crm/leads/11/.
  if (activatedGroups.size === 0 && !bareMatched) {
    var bestMatch = null;
    var bestLen = 0;
    panel.querySelectorAll('.nav-link[href]').forEach(function (link) {
      if (link.hasAttribute('data-toggle')) return;
      var href = link.getAttribute('href');
      if (!href || href === '#' || href === '/') return;
      var a = document.createElement('a');
      a.href = href;
      var linkPath = a.pathname;
      if (currentPath.indexOf(linkPath) === 0 && linkPath.length > bestLen) {
        bestMatch = link;
        bestLen = linkPath.length;
      }
    });
    if (bestMatch) bestMatch.classList.add('active');
  }

  // Expand/collapse groups based on whether they contain an .active link
  panel.querySelectorAll('.collapse').forEach(function (group) {
    var hasActive = group.querySelector('.nav-link.active');
    var trigger = panel.querySelector('[data-target="#' + group.id + '"]');

    if (hasActive) {
      group.classList.add('show');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    } else {
      group.classList.remove('show');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  });
}

// After any HTMX swap (boosted navigation updates the URL)
document.body.addEventListener('htmx:afterSettle', syncCollapseState);

// Initial load
document.addEventListener('DOMContentLoaded', syncCollapseState);
